import React from 'react';
import Button from '../../../components/ui/Button';
import { ModalShell } from '../../../components/ui/ModalFrame';
import { MODAL_LAYER } from '../../../constants/modalLayers';
import { MODAL_DIALOG_ACTIONS_END } from '../../../constants/layoutSpacing';

const TemplateDeleteDialog = ({
  open,
  templateName,
  isDeleting,
  onCancel,
  onConfirm,
}) => {
  if (!open) return null;

  return (
    <ModalShell
      zClass={MODAL_LAYER.standard}
      backdropClassName="bg-black/50"
      panelClassName="bg-card rounded-lg max-w-md w-full p-6 shadow-elevation-lg"
    >
      <h2 className="text-lg font-semibold text-foreground mb-2">
        Excluir modelo
      </h2>

      <p className="text-sm text-muted-foreground mb-6">
        {templateName ? (
          <>
            O modelo <span className="font-medium text-foreground">{templateName}</span> será
            excluído permanentemente. Deseja continuar?
          </>
        ) : (
          'A exclusão do modelo é definitiva e não poderá ser desfeita. Deseja continuar?'
        )}
      </p>

      <div className={MODAL_DIALOG_ACTIONS_END}>
        <Button
          variant="outline"
          onClick={onCancel}
          disabled={isDeleting}
        >
          Cancelar
        </Button>

        <Button
          variant="destructive"
          onClick={onConfirm}
          disabled={isDeleting}
        >
          {isDeleting ? 'Excluindo...' : 'Confirmar exclusão'}
        </Button>
      </div>
    </ModalShell>
  );
};

export default TemplateDeleteDialog;
